import defaultStyle from "../../../styles/defaultPageStyle.module.css"
import React, { useCallback, useEffect, useState } from "react"
import List from "../../../components/List/List"
import { ProductsPupop } from "./ProductsPupop"
import { useGetProducts } from "../../../hooks/Products/useGetProducts"
import { productsMemory } from "../../../Objects/Memory/Memory"
import { ProductEntity } from "../../../Objects/ProductsAndCatalogItems/ProductEntity"
import { EEnableStatusType } from "../../../Enum/EEnableStatusType"
import { useGetCategory } from "../../../hooks/Category/useGetCategory"
import { useTranslation } from "react-i18next"
import { CatalogProductEntity } from "../../../Objects/ProductsAndCatalogItems/CatalogProductEntity"
import { ImportDataPopup } from "../../../components/DataImport/ImportDataPopup"
import { ProductQuickEditPopup } from "../../../components/QuickEditGrid/ProductQuickEditPopup"
import { faTableCells } from "@fortawesome/free-solid-svg-icons"
import { useQuickActionPopup } from "../../../hooks/useQuickActionPopup"

export const ProductsPage: React.FC = () => {
  const { t } = useTranslation("product")

  const [enableProducts, setEnableProducts] = useState(false)

  const { handleGetCategory } = useGetCategory()

  const { handleGetProducts } = useGetProducts()

  const [catalogItem, setCatalogItem] = useState<ProductEntity | undefined>(undefined)

  const [enableImport, setEnableImport] = useState(false)

  const [enableQuickEdit, setEnableQuickEdit] = useState(false)

  const handleOpenQuickEdit = useCallback(() => setEnableQuickEdit(true), [])

  useQuickActionPopup("products-quick-edit", handleOpenQuickEdit)

  useEffect(() => {
    const loadData = async () => {
      await handleGetCategory(async () => await handleGetProducts(() => {}))
    }

    loadData()
  }, [])

  const handleOpenEditePromotion = (id: number) => {
    const promotion = productsMemory.findById(id)!

    handleSwitchEditeOrAdd(true)

    setCatalogItem(promotion)
  }

  const handleSwitchEditeOrAdd = (status: boolean) => {
    setCatalogItem(undefined)

    setEnableProducts(status)
  }

  const handleCopyProduct = () => {
    if (!catalogItem) {
      return
    }

    setCatalogItem(
      new ProductEntity({
        ...catalogItem,
        id: -1,
        catalogProductEntity: new CatalogProductEntity({
          ...catalogItem.catalogProductEntity,
          id: -1,
          iconUrl: "",
        }),
      }),
    )
  }

  return (
    <>
      <div className={defaultStyle.containerList}>
        <List
          enableLocalPagination
          data={productsMemory.getListCards(true)}
          messageCount={t("list:label_products_page_message_count")}
          messageEmpty={t("list:label_products_page_message_empty")}
          nameFindSearch={t("list:label_products_page_place_holder")}
          nameDropdown={Object.mapEnumToStrings(EEnableStatusType)}
          handleAddButton={() => handleSwitchEditeOrAdd(true)}
          handleRefreshButton={() => handleGetProducts(() => {})}
          handleOnClick={(e) => handleOpenEditePromotion(e)}
          handleExtraFloatButton={handleOpenQuickEdit}
          extraFloatButtonIcon={faTableCells}
          extraFloatButtonDescriptionKey="interactionDescriptions:pages.products.products.productsPage.button.handleQuickEditProducts"
          handleImportFloatButton={() => setEnableImport(true)}
        />
      </div>

      {enableProducts && (
        <ProductsPupop
          products={catalogItem}
          title={catalogItem && catalogItem.id !== -1 ? t("title_popup_edite") : t("title_popup_create")}
          onClonse={() => handleSwitchEditeOrAdd(false)}
          onCopy={handleCopyProduct}
        />
      )}

      {enableImport && (
        <ImportDataPopup
          target="produtos"
          title={t("dataImport:title", { target: t("dataImport:target_products") })}
          onClose={() => setEnableImport(false)}
          onImported={() => handleGetProducts(() => {})}
        />
      )}

      {enableQuickEdit && (
        <ProductQuickEditPopup
          products={productsMemory.getAll()}
          onClose={() => setEnableQuickEdit(false)}
          onReload={async () => await handleGetProducts(() => {})}
        />
      )}
    </>
  )
}
